document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.getElementById('checkout');
  const cartForm = document.getElementById('cart');
  const icon = document.querySelector('.cart-icon');
  const cartCount = document.querySelector('.cart-items-count');
  const cartClose = document.querySelector('.cart-close-icon');
  const popupWrapper = document.querySelector('.cart-popup-wrapper');
  const currency = document.querySelector('.cart-popup').dataset.currencySymbol;
  const cartCountNumber = document.querySelector('.cart-count');

  if (icon && popupWrapper) {
    icon.addEventListener('click', function (e) {
      const hidden = popupWrapper.classList.contains('dni');
      if (hidden) {
        popupWrapper.classList.remove('dni');
        fetchCartData();
      } else {
        popupWrapper.classList.add('dni');
      }
    });
    cartClose.addEventListener('click', function (e) {
      e.preventDefault();
      popupWrapper.classList.add('dni');
    });

    if (cartCountNumber) {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          cartCountNumber.innerText = cart.items.length > 0 ? cart.items.length : '';
        });
    }
  }
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function (e) {
      e.preventDefault();
      cartForm.submit();
    });
  }

  const itemsContainer = popupWrapper.querySelector('.cart__items');
  const subtotalPrice = popupWrapper.querySelector('.cart-popup-subtotal-price');

  // Handle quantity changes
  itemsContainer.addEventListener('click', (e) => {
    if (e.target.matches('.quantity-button')) {
      const grid = e.target.closest('.cart-grid');
      const itemKey = grid.dataset.itemKey;
      const change = e.target.dataset.change === 'increase' ? 1 : -1;
      const curQty = parseInt(grid.querySelector('input[type=number').value);
      if (change === -1 && curQty === 1) {
      } else {
        const v = curQty + change;
        grid.querySelector('input[type=number').value = v;
        updateQuantity(itemKey, v);
      }
    } else if (e.target.matches('.remove-item')) {
      const itemKey = e.target.dataset.itemKey;
      updateQuantity(itemKey, 0);
    }
  });

  async function updateQuantity(itemKey, q) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: q,
        }),
      });

      const cart = await response.json();
      this.renderCart(cart);
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  }

  async function fetchCartData() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  function resizeImageUrl(url, size) {
    const urlParts = url.split('.');
    const extension = urlParts.pop();
    const baseName = urlParts.join('.');
    const resizedUrl = `${baseName}_${size}.${extension}`;

    return resizedUrl;
  }

  function renderCart(cart) {
    cartCount.innerText = cart.items > 1 ? `${cart.items.length} items` : `${cart.items.length} item`;
    cartCountNumber.innerText = cart.items.length > 0 ? cart.items.length : '';

    itemsContainer.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-grid" data-item-key="${item.key}">
        <div class="cart-grid-thumb">
          <a href="${item.url}"><img class="cart-item-image" src="${resizeImageUrl(
          item.image,
          '200x'
        )}" width="100"></a>
        </div>
        <div class="cart-grid-details">
          <div class="fade xs">${item.vendor}</div>
          <div class="mt1">
            <a href="${item.url}">${item.title}</a>
          </div>
        </div>
        <div class="cart-grid-quantity">
          <div class="number-input w-100">
            <button type="button" class="quantity-button" data-change="decrease">-</button>
            <input type="number" name="updates[]" id="updates_${item.key}" value="${
          item.quantity
        }" min="0" class="quantity-selector" data-item-price="${item.price}" data-line-item-key="${item.key}">
            <button type="button" class="quantity-button" data-change="increase">+</button>
          </div>
        </div>
        <div class="cart-grid-action mt2">
          <a href="${item.url}" style="font-size:14px">Edit details</a>
          <button class="ml2 remove-item ghost" type="button" data-item-key="${item.key}">Remove</button>
        </div>
        <div class="cart-grid-price mt2">
          <h3 class="ma0 normal black">${formatMoney(item.final_line_price)}</h3>
        </div>
      </div>
    `
      )
      .join('');

    // Track removal

    subtotalPrice.textContent = formatMoney(cart.total_price);
  }

  async function updateQuantity(itemKey, change) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: change,
        }),
      });

      const cart = await response.json();
      renderCart(cart);
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  }

  function formatMoney(cents) {
    return currency + (cents / 100).toLocaleString('en-US');
  }
});
